export default __webpack_public_path__ + "static/media/twitter.72b929f3.svg";